<template>
    <section class="c-video-audio-integrate">
        <div
            v-if="content"
            class="c-video-audio-integrate--loaded"
        >
            <div class="c-video-audio-integrate__wrapper">
                <div class="c-video-audio-integrate__texts">
                    <h2 class="c-video-audio-integrate__title">
                        {{ content.title2 }}
                    </h2>
         
                    <div class="c-video-audio-integrate__all-items">
                        <div
                            v-for="integrate in content.albums.filter(album => album.group ==='album2')"
                            :key="integrate.id"
                            class="c-video-audio-integrate__item"
                        >
                            <img
                                src="@/modules/mvp/assets/tick.png"
                                alt=""
                            >
                            <span><h3 class="bold">{{ `${integrate.title}:` }}</h3><p class="light">{{ ` ${integrate.description}` }}</p></span>
                        </div>
                        <div
                            v-if="content.custom && content.custom['field2'] && content.custom['field1']"
                            class="c-video-audio-integrate__action"
                        >
                            <y-button
                                color="primary"
                                :tag="isLink(content.custom['field2']) ? 'a' : 'router-link'"
                                :to="content.custom['field2']"
                                :href="content.custom['field2']"
                                :content="content.custom['field1']"
                                size="normal"
                                flat
                                :no-padding="true"
                            />
                        </div>
                    </div>
                </div>
                <div class="c-video-audio-integrate__image">
                    <img
                        :src="imgSrc(content.image)"
                        alt=" "
                        tabindex="-1"
                    >
                </div>
            </div>
            <div class="c-video-audio-integrate__testimonials">
                <y-our-clients-say
                    v-if="clientsSay && content"
                    :content="content"
                    :clients-say="clientsSay"
                    title-tag="h2"
                    :header-img="true"
                    :different-title="true"
                />
            </div>

            <div>
                <y-call-to-action :content="content" />
            </div>
        </div>
    </section>
</template>

<script >
    import { isLink } from '@/helpers/helpers';
    import YOurClientsSay from '@modules/video-audio/components/OurClientsSay/Index.vue';
    import YCallToAction from '@modules/video-audio/components/CallToAction/Index.vue';

    export default {
        name: 'VideoAudioIntegrate',

        components: {
            YOurClientsSay,
            YCallToAction,
        },

        props: {
            content   : Object,
            clientsSay: {
                type: Array,
            },
        },

        /**
         *
         * @inheritDoc
         */
        methods: {
            isLink,
        },
    };

</script>

<style lang="scss" src="./integrate.scss"/>
